// 한 페이지에 픽셀이 여러 개 init 되면 fbq("track")은 전부에 전송되므로,
// 각 픽셀은 자기 이벤트만 받도록 항상 trackSingle 로 보낸다.
export const SITE_META_PIXEL_ID = "2233548260513740";
// 가맹문의(/inquiry/center) 광고 캠페인 전용 픽셀
export const CENTER_INQUIRY_META_PIXEL_ID = "229176770750846";

type MetaPixelEventName = "PageView" | "Lead";

declare global {
  interface Window {
    fbq?: (
      command: "trackSingle",
      pixelId: string,
      eventName: MetaPixelEventName,
    ) => void;
  }
}

export function trackMetaPixelEvent(
  pixelId: string,
  eventName: MetaPixelEventName,
): void {
  if (typeof window === "undefined" || typeof window.fbq !== "function") {
    return;
  }

  window.fbq("trackSingle", pixelId, eventName);
}
